module.exports = __webpack_public_path__ + "img/two.439af5d4.png";